/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function _addMeToCart(e, el) {
// e = e || window.event;
// e.preventDefault();

// let formData = {
// 'items': [
// {
// 'id': el.dataset.variant_id,
// 'quantity': 1
// }
// ]
// };

// fetch('/cart/add.js', {
// method: 'POST',
// headers: {
// 'Content-Type': 'application/json'
// },
// body: JSON.stringify(formData)
// })
// .then((resp) => {
// return resp.json();
// })
// .then((data) => {

// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
// bubbles: true,
//   detail:{
//     action : "add",
//     data: data
//   }
// }));
// })
// .catch((err) => {
// console.error('Error: ' + err);
// })
// }

//  document.addEventListener("submit", function(event) {
//     event.preventDefault();
//     var form = event.target;
//     var formData = new FormData(form);
//     var xhr = new XMLHttpRequest();
//     xhr.open("POST", form.action, true);
//     xhr.onreadystatechange = function() {
//       if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
//         window.location.href = "/checkout";
//       }
//     };
//     xhr.send(formData);
//   });
// console.log("custom file running");
// document.addEventListener("cart:refresh",e=>feed_cart_to_backend(e.detail));
document.addEventListener("theme:loading:end", (e) =>
  feed_cart_to_backend(e.detail)
);

async function feed_cart_to_backend(cart) {
  console.log(cart);

  if (!cart) return;
  if (cart.data.message) return;
  if (
    window.our_admin_id &&
    sessionStorage.customer_id &&
    sessionStorage.cartSync
  ) {
    console.log("first");
    cart.admin_name = our_admin_name;
    cart.admin_id = our_admin_id;
    cart.customer_id = sessionStorage.customer_id;
    cart.customer_name = sessionStorage.customer_name;
    cart.customer_email = sessionStorage.customer_email;
  } else if (window.our_customer_id) {
    console.log("second");
    cart.customer_id = our_customer_id;
    cart.customer_name = our_customer_name;
    cart.customer_email = our_customer_email;
  } else {
    console.log("return pls");

    return;
  }

  if (cart.action === "add") {
    let completeCartObject = await fetch("/cart.js")
      .then((x) => x.json())
      .catch((err) => false);
    if (completeCartObject) cart.data = completeCartObject;
  }
  console.log(cart);

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(cart);

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(
    "https://abfu0jdwg6.execute-api.ap-south-1.amazonaws.com/CustomerCart/update",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => {
      console.log(result);
    })
    .catch((error) => console.log("error", error));
}

async function shareCartHandler() {
  const cart = await fetch("/cart.js").then((x) => x.json());
  if (!cart) return;
  if (cart.items.length === 0) {
    alert("Your cart is empty");
    return;
  }
  const variantsString = cart.items
    .map((x) => {
      return `${x.id}:${x.quantity}`;
    })
    .join(",");
  const url = `${location.origin}/cart/${variantsString}?storefront=true`;
  const anchor = document.createElement("a");
  if (navigator.platform?.toLowerCase() !== "iphone") {
    anchor.target = "_blank";
  }
  anchor.href = `https://api.whatsapp.com/send?text=${url}`;
  anchor.click();
}

function functionGSTsvgbtn() {
  var gstclsbttn1 = document.getElementById("gstIn");
  gstclsbttn1.setAttribute("aria-hidden", "true");
}

jQuery(document).ready(function ($) {
    $('.custom-form-scale-1').submit(function (e) {
        e.preventDefault();

        console.log("Form submission started.");

        // Show loading indicator
        $('.loading-indicator').show();
        console.log("Loading indicator shown.");

        // Collect form data
        var data = Object.fromEntries(new FormData(e.target).entries());
        console.log("Collected form data:", data);

        var _uploadImage = e.target['additional_col4'].files[0];
        var fullName = (data['first_name'] || '').trim() + ' ' + (data['last_name'] || '').trim();
        console.log("Full name constructed:", fullName);

        // Function to convert image file to base64
        const getBase64 = function (file) {
            console.log("Converting image file to Base64...");
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    console.log("Image successfully converted to Base64.");
                    resolve(reader.result);
                };
                reader.onerror = (error) => {
                    console.error("Error converting image to Base64:", error);
                    reject(error);
                };
            });
        };

        // Ensure image is uploaded
        if (!_uploadImage) {
            alert("Please upload an image.");
            console.log("No image uploaded. Form submission halted.");
            $('.loading-indicator').hide();
            return;
        }

        // Convert the image to Base64
        getBase64(_uploadImage)
            .then(function (base64Image) {
                console.log("Base64 image conversion complete.");

                // Image upload data
                const imageFormData = new FormData();
                imageFormData.append('name', fullName);
                imageFormData.append('email', data['email']);
                imageFormData.append('phone', data['phone']);
                imageFormData.append('pincode', data['additional_col2']);
                imageFormData.append('city', data['additional_col3']);
                imageFormData.append('exchange_product', data['additional_col5']);
                imageFormData.append('image', base64Image);

                console.log("Prepared image form data for upload.");

                // Upload the image
                console.log("Sending image upload request to image.php...");
                return fetch('https://info.baywindow.co.in/image.php', {
                    method: 'POST',
                    body: imageFormData
                });
            })
            .then(function (imageResponse) {
                console.log("Received response from image.php.");
                if (!imageResponse.ok) {
                    console.error("Image upload failed with status:", imageResponse.status);
                    return imageResponse.json().then(function (error) {
                        throw new Error('Image upload failed: ' + (error.error || 'Unknown error'));
                    });
                }
                return imageResponse.json();
            })
            .then(function (imageResult) {
                console.log("Image.php response data:", imageResult);

                if (!imageResult.imagePath) {
                    console.error("Image path not received from server.");
                    throw new Error('Image path not received from server.');
                }

                const imagePath = imageResult.imagePath;
                console.log("Image successfully uploaded. Image path:", imagePath);

                // Prepare email data
                const mailFormData = new FormData();
                mailFormData.append('name', fullName);
                mailFormData.append('email', data['email']);
                mailFormData.append('phone', data['phone']);
                mailFormData.append('pincode', data['additional_col2']);
                mailFormData.append('city', data['additional_col3']);
                mailFormData.append('exchange_product', data['additional_col5']);
                mailFormData.append('image_path', imagePath);

                console.log("Prepared mail form data for sending.");

                // Send email in the background
                console.log("Sending email request to mail.php...");
                return fetch('https://info.baywindow.co.in/mail.php', {
                    method: 'POST',
                    body: mailFormData
                });
            })
            .then(function (mailResponse) {
                console.log("Received response from mail.php.");
                if (!mailResponse.ok) {
                    console.error("Mail sending failed with status:", mailResponse.status);
                    return mailResponse.text().then(function (errorText) {
                        throw new Error('Mail sending failed: ' + errorText);
                    });
                }
                return mailResponse.text();
            })
            .then(function (mailResult) {
                console.log("Mail.php response data:", mailResult);
                console.log("Form submission completed successfully.");
                window.location.href = 'https://baywindow.co.in/pages/thank-you';
            })
            .catch(function (error) {
                // Handle errors and show error messages
                console.error('Error occurred during form submission:', error.message);
                alert('An error occurred: ' + error.message);
            })
            .finally(function () {
                // Hide loading indicator once done
                $('.loading-indicator').hide();
                console.log("Loading indicator hidden. Form submission process ended.");
            });
    });
});




